<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'UserList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-header">
              <h4 class="card-title">{{ item && item['title'] }}</h4>
            </div>
            <div class="card-body">
              <b-row>
                <b-col>
                  <UserForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserForm from './Form.vue'
import Loader from '../../Layout/Loader'

export default {
  components: {
    UserForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'user/update/isLoading',
      error: 'user/update/error',
      deleteError: 'user/del/error',
      deleteLoading: 'user/del/isLoading',
      created: 'user/create/created',
      deleted: 'user/del/deleted',
      retrieved: 'user/update/retrieved',
      updated: 'user/update/updated',
      violations: 'user/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'UserList' })
    },

    updated: function (updated) {
      this.$Swal({
        title: updated.username + ' ' + this.$t('notifications.updated'),
        type: 'success',
        showConfirmButton: false,
        timer: 1500
      })
      this.$router.push({ name: 'UserShow', params: { id: updated['@id'] } })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'user/create/reset',
      deleteItem: 'user/del/del',
      delReset: 'user/del/reset',
      retrieve: 'user/update/retrieve',
      updateReset: 'user/update/reset',
      update: 'user/update/update',
      updateRetrieved: 'user/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this user ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
